import { loadCategories, loadSite, loadWorks, url } from "./api";
import { categoryName, escapeHtml, renderMedia } from "./render";
import { workById } from "./gallery";

export async function initWork(): Promise<void> {
  const id = new URLSearchParams(location.search).get("id") ?? "";
  const root = document.getElementById("pieza");
  if (!root) return;

  const [works, cats, site] = await Promise.all([loadWorks(), loadCategories(), loadSite()]);
  const work = workById(works, id);
  if (!work) {
    root.innerHTML = `<p class="empty">No encuentro esa pieza. <a href="${url("trabajos.html")}">Volver a los trabajos</a>.</p>`;
    return;
  }

  document.title = `${work.title} — By Norma Figueroa`;
  const orderHref = url(`pedido.html?obra=${encodeURIComponent(work.id)}`);
  root.innerHTML = `
    <div class="work-stage">
      ${work.media.map((item) => renderMedia(item)).join("")}
    </div>
    <div class="work-copy">
      <p class="kicker">${escapeHtml(categoryName(work.category, cats))}</p>
      <h1>${escapeHtml(work.title)}</h1>
      <div class="prose">${work.description}</div>
      <p style="margin-top:1.4rem">
        <a class="btn" href="${orderHref}">Pedir esta u otras</a>
        <a class="btn btn-ghost" href="${url("trabajos.html")}">Todas</a>
      </p>
      <p class="form-note" style="margin-top:1rem">Cada horneada es distinta. ${escapeHtml(site.artistName)} puede hacer una lectura nueva, no una copia.</p>
    </div>
  `;
}
